import { useId } from 'react';

export const LiquidityHubIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  const gradientId = useId();

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="48" height="48" rx="8" fill={`url(#${gradientId})`} />

      <path
        data-nav-part="hub-center"
        d="M32.0335 23.2635H28.6901C28.3721 21.2325 26.767 19.6279 24.7365 19.31V15.9665C24.7365 15.5603 24.4062 15.23 24 15.23C23.5938 15.23 23.2635 15.5603 23.2635 15.9665V19.31C21.232 19.6279 19.6269 21.2336 19.3094 23.2656C19.3038 23.2656 19.2981 23.264 19.2924 23.264H15.9665C15.5603 23.264 15.23 23.5943 15.23 24.0005C15.23 24.4067 15.5603 24.737 15.9665 24.737H19.2924C19.2981 24.737 19.3038 24.7355 19.3094 24.7355C19.6269 26.767 21.232 28.3726 23.2635 28.6911V32.0346C23.2635 32.4407 23.5938 32.7711 24 32.7711C24.4062 32.7711 24.7365 32.4407 24.7365 32.0346V28.6911C26.7675 28.3732 28.3721 26.768 28.6901 24.7376H32.0335C32.4392 24.7376 32.77 24.4072 32.77 24.001C32.77 23.5948 32.4392 23.2635 32.0335 23.2635Z"
        fill="white"
      />
      <path
        data-nav-part="hub-up"
        d="M24.0001 14.2926C25.7377 14.2926 27.1464 12.884 27.1464 11.1463C27.1464 9.40865 25.7377 8 24.0001 8C22.2624 8 20.8538 9.40865 20.8538 11.1463C20.8538 12.884 22.2624 14.2926 24.0001 14.2926Z"
        fill="white"
      />
      <path
        data-nav-part="hub-left"
        d="M11.1463 27.1466C12.884 27.1466 14.2926 25.738 14.2926 24.0003C14.2926 22.2627 12.884 20.854 11.1463 20.854C9.40865 20.854 8 22.2627 8 24.0003C8 25.738 9.40865 27.1466 11.1463 27.1466Z"
        fill="white"
      />
      <path
        data-nav-part="hub-down"
        d="M24.0001 40.0001C25.7377 40.0001 27.1464 38.5915 27.1464 36.8538C27.1464 35.1162 25.7377 33.7075 24.0001 33.7075C22.2624 33.7075 20.8538 35.1162 20.8538 36.8538C20.8538 38.5915 22.2624 40.0001 24.0001 40.0001Z"
        fill="white"
      />
      <path
        data-nav-part="hub-right"
        d="M36.8536 27.1466C38.5912 27.1466 39.9999 25.738 39.9999 24.0003C39.9999 22.2627 38.5912 20.854 36.8536 20.854C35.1159 20.854 33.7073 22.2627 33.7073 24.0003C33.7073 25.738 35.1159 27.1466 36.8536 27.1466Z"
        fill="white"
      />

      <defs>
        <linearGradient
          id={gradientId}
          x1="5"
          y1="3.5"
          x2="41.5"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#85CCFF" />
          <stop offset="1" stopColor="#0085E3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
